/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const scrollport = document.querySelector('[data-scrollport]');
    if (!navigation) return;

    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            if (scrollport) scrollport.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            if (scrollport) scrollport.style.overflowY = null;
        }
    });
})();

/* Apply a saved or first-entry locale preference */
(function () {
    locale();
})();

/* Float the inner scrollbar over content instead of reserving a white gutter */
(function () {
    overlayScrollbar();
})();

/* Localize and bind recovery controls on Ghost error routes */
(function () {
    errorRecovery();
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    if (document.querySelector('.gh-navigation')) {
        dropdown();
    }
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Opening intro animation */
(function () {
    intro();
})();

/* Work opening — expand a case study under its row instead of navigating */
(function () {
    workOpening();
})();

/* Work closing — collapse the case study before returning to the overview */
(function () {
    workClosing();
})();

/* CV reading focus — fade entries by their distance from the reading line */
(function () {
    cvFocus();
})();

/* Page cross-fade between Work, About and Contact */
(function () {
    pageTransition();
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
